module.exports = __webpack_public_path__ + "static/binary-0a7bc40c3bdea190a4527f9e8aabd24a.mp4";